import React, { Component } from 'react';

import ZSelectField from '../../Utility/ZSelectField';

export default class RankedMetricSlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.editMetric = this.editMetric.bind(this);
        this.selectKpi = this.selectKpi.bind(this);
    }

    editMetric(field, value) {
        let metric = this.props.metric;

        if (metric[field] != value) {
            metric[field] = value;
        }

        this.props.editMetric(metric);
    }

    selectKpi(kpiName) {
        let selected = this.props.kpiMap[kpiName][this.props.kpiField];

        this.editMetric(this.props.kpiField, selected);
    }

    render() {
        let metric = this.props.metric;

        let hideStyle = { opacity: '0', pointerEvents: 'none' };

        let activeKpiList = Object.keys(this.props.kpiMap);

        let metricIconActive = false;
        if (metric[this.props.kpiField] != null) {
            metricIconActive = true;
        }

        let highOptionClass = !metric.isLowerBetter ? 'gc-highlow-button gc-button--active' : 'gc-highlow-button';
        let lowOptionClass = metric.isLowerBetter ? 'gc-highlow-button gc-button--active' : 'gc-highlow-button';
        let highOptionStyle = { left: '1rem' };
        let lowOptionStyle = { left: '50%' };

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? 17 : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className={"material-icons gc-double-icon spot1" + (metricIconActive ? ' active' : '')}>equalizer</div>
                <div className={"material-icons gc-double-icon spot2 active"} style={metric.isLowerBetter ? hideStyle : {}}>trending_up</div>
                <div className={"material-icons gc-double-icon spot2 active"} style={!metric.isLowerBetter ? hideStyle : {}}>trending_down</div>

                <div className="gc-question metric">{"By which metric are you ranking contestants?"}</div>
                <div className="gc-metric-selector-container">
                    <ZSelectField
                        id="gc-metric-select-field"
                        placeholder="Select Metric"
                        defaultValue={null}
                        className={"gc-z-selector metric"}
                        menuItems={activeKpiList}
                        onChange={this.selectKpi}
                        value={metric[this.props.kpiField] != null ? this.props.kpiMapReverse[metric[this.props.kpiField]].name : null}
                        activeColor="rgba(0, 126, 181, 1)"
                        isBlocked
                    />
                </div>

                <div className="gc-question highlow">{"Is it better for this metric's value to be higher or lower?"}</div>
                <div className={highOptionClass} style={highOptionStyle} onClick={this.editMetric.bind(null, "isLowerBetter", false)}>{"Higher"}</div>
                <div className={lowOptionClass} style={lowOptionStyle} onClick={this.editMetric.bind(null, "isLowerBetter", true)}>{"Lower"}</div>
            </div>
        );
    }
}